import React, { ReactNode } from "react"
import { Stack, TypographyProps } from "@chakra-ui/react"
import SectionHeader from "./SectionHeader"

type Props = {
  children: ReactNode
  title: string
  actionButtons?: ReactNode[]
  description?: string | ReactNode
  headingSize?: TypographyProps["fontSize"]
}

const SettingsSection = ({
  children, title, actionButtons, description, headingSize,
}: Props) => (
  <Stack spacing={4}>
    <SectionHeader
      description={description}
      actionButtons={actionButtons}
      headingSize={headingSize}
    >
      {title}
    </SectionHeader>
    {children}
  </Stack>
)

export default SettingsSection
